'use strict';

// Media.js
// functions to check and get the media query that the window size
// does or does not match

export default function() {

    var _self,
        breakpoints;

    return {
        init: function(context) {
            _self = this;

            breakpoints = {
                xsmall: 370,
                small: 625,
                medium: 850,
                large: 1050,
                xlarge: 1215
            };

            if (context) {
                return this.meetsContext(context);
            }
        },

        getCurrentQuery: function() {
            var mq = 'mq-small', // TODO Decide small image size - 675px?
                winWidth = document.body.clientWidth;
            if (winWidth > breakpoints.large) {
                mq = 'mq-large'; // TODO Decide large image size - 1440px?
            } else if (winWidth > breakpoints.small) {
                mq = 'mq-medium'; // TODO Decide medium image size - 1050px?
            }

            return mq;
        },

        meetsContext: function(context) {
            var meets = false,
                mq = this.getCurrentQuery();

            if (context === mq || context === '') {
                meets = true;
            }

            return meets;
        }
    };

}
